import React from 'react';
import { CheckCircleIcon, LightbulbIcon } from 'lucide-react';
export function FeaturesSection() {
  const features = ['Every remedy is tested and family-safe', 'Uses common kitchen ingredients', 'Beginner-friendly—no niche tools', 'Organized by ailment, so you find answers fast', 'Designed for everyday use AND emergencies'];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-175">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-177">
          <LightbulbIcon className="w-10 h-10 text-emerald-700" data-id="element-178" />
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-179">
            What Makes This Guide Different
          </h2>
        </div>
        <p className="text-xl text-stone-700 mb-12 text-center" data-id="element-180">
          Unlike random blogs or DIY recipes…
        </p>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-181">
          {features.map((feature, index) => <div key={index} className="flex items-start gap-4 bg-emerald-50 p-6 rounded-lg" data-id="element-182">
              <CheckCircleIcon className="w-6 h-6 text-emerald-700 flex-shrink-0 mt-1" data-id="element-183" />
              <p className="text-lg text-stone-700" data-id="element-184">{feature}</p>
            </div>)}
        </div>
        <div className="text-center bg-stone-700 text-white rounded-xl p-8" data-id="element-185">
          <p className="text-2xl font-bold mb-2" data-id="element-186">
            It's simple, effective, and fast.
          </p>
          <p className="text-lg" data-id="element-187">
            Over 10,000 families have already transformed their health.
          </p>
        </div>
      </div>
    </section>;
}